<template>
    <div class="time-slots-list-container" v-if="isOpen">
        <div class="time-slots-list" ref="time-slots-list">
            <time-slot-entry
                v-for="(pickupTime, i) in pickupTimes"
                :key="i"
                :retrieval-method="retrievalMethod"
                :time-slot="pickupTime"
                :selected="selectedTimeSlot && pickupTime.start().getTime() === selectedTimeSlot.start().getTime()"
                :current="pickupTime === currentTimeSlot"
                @selected="selectPickupTime(pickupTime)"
                :ref="'timeslot-' + pickupTime.start().getTime()"
            >
            </time-slot-entry>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import TimeSlotEntry from '@/components/front/time-scheduler/TimeSlotEntry.vue';
import { getModule } from 'vuex-module-decorators';
import TimeSchedulerModule, { OrderRetrievalMethod } from '@/stores/modules/time-scheduler';
import TimeSlot, { TimeSlotState } from '@/models/time-slot';

@Component({
    components: { TimeSlotEntry }
})
export default class TimeSlotsList extends Vue
{
    @Prop(String) readonly retrievalMethod!: OrderRetrievalMethod;
    @Prop(Boolean) readonly isOpen!:boolean;
    @Prop(Object) readonly selectedTimeSlot!: TimeSlot;

    timeSchedulerModule!: TimeSchedulerModule;

    public created() {
        this.timeSchedulerModule = getModule(TimeSchedulerModule, this.$store);
    }

    @Emit('select')
    selectPickupTime(timeSlot: TimeSlot) {
        return timeSlot;
    }

    get pickupTimes() {
        return this.timeSchedulerModule.timeSlots.filter((timeSlot: TimeSlot) => timeSlot.state !== TimeSlotState.PAST);
    }

    get currentTimeSlot() {
        return this.timeSchedulerModule.currentTimeSlot;
    }

    get TimeSlotState() {
        return TimeSlotState;
    }

    @Watch('isOpen')
    scrollToSlot() {
        if (this.isOpen) {
            this.$nextTick(() => {
                let selectedTimeSlot: HTMLElement | null = null;
                let topPosition: number = 0;

                if (this.selectedTimeSlot) {
                    selectedTimeSlot = (<HTMLElement>(<Vue[]>this.$refs['timeslot-' + this.selectedTimeSlot.start().getTime()])?.[0].$el);
                } else if (this.currentTimeSlot) {
                    selectedTimeSlot = (<HTMLElement>(<Vue[]>this.$refs['timeslot-' + this.currentTimeSlot.start().getTime()])?.[0].$el)
                }
                if (selectedTimeSlot) {
                    topPosition = selectedTimeSlot.offsetTop;
                }

                const timeSlotsList = <HTMLElement>this.$refs['time-slots-list'];
                if (timeSlotsList) {
                    timeSlotsList.scrollTo({top: topPosition});
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.time-slots-list-container {
    @include breakpoint(medium down) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--time-modal-list-mobile-bg);
    }
}

.time-slots-list {
    list-style-type: none;
    margin: 0;
    height: 300px;
    overflow-y: scroll;
    position: relative;
    @include breakpoint(medium down) {
        position: absolute;
        bottom: 30px;
        width: calc(100% - 60px); // remove margin left and right
        margin: 0px 30px;
        background: var(--time-modal-list-mobile-fg);
        border: 1px solid var(--time-modal-list-mobile-border);
        border-radius: $border-radius-card;
    }
}

</style>
